document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchProductTemplate",
    function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
      const hitHandle =
        hit && algoliaShopify?.helpers?.instantsearchLink ? algoliaShopify.helpers.instantsearchLink(hit) : "";
      const product = {
        id: hit.id,
        variant: hit.objectID,
        vendor: hit.vendor,
        title: hit.title,
        condition: hit.meta?.custom?.condition ?? null,
        price: hit.price,
        compare_at_price: hit.compare_at_price,
        url: "https://" + window.location.host + hitHandle,
        image: algoliaShopify.helpers.largeImage(hit),
        alt: `${hit.title} - Variant ${hit.objectID}`,
        inventory_quantity: hit.inventory_quantity,
        handle: hit.handle,
        social_count: hit.meta?.swym_wishlist?.wishlist_social_count ?? null,
        images: hit.meta?.custom?.images,
      };

      const onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        trackSearchAttribution(hit);
        window.location.assign(product.url);
      };

      return html`${renderInjectedProductCard(product, onClick, hit, html)}`;
    },
  );
});
